//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalDeniedRulesWidget = ({ count }: { count: string | number }) => {
  return <StatCard title='Denied - 3 Year Rule' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default TotalDeniedRulesWidget;
